var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.95 29.0652L130.6 46.7069M124.3 13.5236L76.575 61.2486C74.1091 63.711 72.4273 66.8484 71.7417 70.2652L67.3334 92.3319L89.4 87.9152C92.8167 87.2319 95.95 85.5569 98.4167 83.0902L146.142 35.3652C147.576 33.9311 148.713 32.2285 149.49 30.3547C150.266 28.4809 150.665 26.4726 150.665 24.4444C150.665 22.4162 150.266 20.4079 149.49 18.5341C148.713 16.6603 147.576 14.9577 146.142 13.5236C144.708 12.0894 143.005 10.9518 141.131 10.1756C139.257 9.39948 137.249 9 135.221 9C133.193 9 131.184 9.39948 129.311 10.1756C127.437 10.9518 125.734 12.0894 124.3 13.5236Z",
    stroke: "white",
    strokeWidth: 16.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 108.999V133.999C134 138.419 132.244 142.658 129.118 145.784C125.993 148.909 121.754 150.665 117.333 150.665H25.6667C21.2464 150.665 17.0072 148.909 13.8816 145.784C10.7559 142.658 9 138.419 9 133.999V42.3319C9 37.9116 10.7559 33.6724 13.8816 30.5468C17.0072 27.4212 21.2464 25.6652 25.6667 25.6652H50.6667",
    stroke: "white",
    strokeWidth: 16.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.11d5b83911626ee5097d289b171ab84e.svg";
export { ForwardRef as ReactComponent };